import { Filter, Globe, Building2, Users } from 'lucide-react';

export type VisibilityFilter = 'all' | 'global' | 'workspace' | 'group';

interface VisibilityPillsProps {
  value: VisibilityFilter;
  onChange: (value: VisibilityFilter) => void;
}

const PILLS: { key: VisibilityFilter; label: string; icon: typeof Filter; activeClass: string; idleClass: string }[] = [
  { key: 'all', label: 'Todos', icon: Filter, activeClass: 'bg-[#F4CC04] text-black', idleClass: 'bg-[#2a2a2a] text-[#888888] hover:bg-[#333333] hover:text-white' },
  { key: 'global', label: 'Global (TD)', icon: Globe, activeClass: 'bg-purple-500 text-white', idleClass: 'bg-[#2a2a2a] text-purple-400 hover:bg-[#333333]' },
  { key: 'workspace', label: 'Workspace', icon: Building2, activeClass: 'bg-blue-500 text-white', idleClass: 'bg-[#2a2a2a] text-blue-400 hover:bg-[#333333]' },
  { key: 'group', label: 'Pessoal', icon: Users, activeClass: 'bg-green-500 text-white', idleClass: 'bg-[#2a2a2a] text-green-400 hover:bg-[#333333]' },
];

export const VisibilityPills = ({ value, onChange }: VisibilityPillsProps) => (
  <div className="flex items-center gap-2 overflow-x-auto pb-1">
    {PILLS.map(({ key, label, icon: Icon, activeClass, idleClass }) => (
      <button
        key={key}
        onClick={() => onChange(key)}
        className={`
          flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium
          transition-colors whitespace-nowrap flex-shrink-0
          ${value === key ? activeClass : idleClass}
        `}
      >
        <Icon className="w-3.5 h-3.5" />
        {label}
      </button>
    ))}
  </div>
);
